import script from "./help-drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./help-drawer.vue?vue&type=script&setup=true&lang=js"

import "./help-drawer.vue?vue&type=style&index=0&id=aecf7cb4&scoped=true&lang=css"
import "./help-drawer.vue?vue&type=style&index=1&id=aecf7cb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aecf7cb4"]])

export default __exports__